import ApiService from './api';
import type { ApiResponse } from '~/types/api';

/**
 * Bülten aboneliği için yanıt tipi
 */
interface NewsletterResponse {
  status: string;
  message: string;
}

export interface NewsletterSubscribeData {
  email: string;
  recaptchaToken?: string; // reCAPTCHA token'ı için eklendi
}

/**
 * Bülten aboneliği servisi
 */
export class NewsletterService {
  private static instance: NewsletterService;
  private apiService: ApiService;

  /**
   * Özel constructor - singleton pattern
   */
  private constructor() {
    this.apiService = ApiService.getInstance();
  }

  /**
   * Servis örneği al
   */
  public static getInstance(): NewsletterService {
    if (!NewsletterService.instance) {
      NewsletterService.instance = new NewsletterService();
    }
    return NewsletterService.instance;
  }

  /**
   * Bülten aboneliği
   * @param email Abone olunacak e-posta
   * @param recaptchaToken reCAPTCHA token'ı (opsiyonel)
   */
  public async subscribe(email: string, recaptchaToken?: string): Promise<NewsletterResponse> {
    try {
      const data: NewsletterSubscribeData = { email };
      
      // reCAPTCHA token'ı varsa ekle
      if (recaptchaToken) {
        data.recaptchaToken = recaptchaToken;
      }
      
      const response = await this.apiService.post<ApiResponse<any>>('/newsletter/subscribe', data);
      
      return {
        status: 'success', // API başarıyla yanıt verdiyse success dön
        message: response.message || 'Bülten aboneliğiniz başarıyla gerçekleşti.'
      };
    } catch (error) {
      console.error('Bülten aboneliği hatası:', error);
      return {
        status: 'error',
        message: 'Bülten aboneliği sırasında bir hata oluştu.'
      };
    }
  }
} 